<script>
	import { onMount } from 'svelte';
	import Identity from 'svelte-key';
	import { cachedFetch, openSearchDb, fetchData, generateID, loadCacheIndex, hasCache, getCache, setCache, isTouchEnabled, layerChanged } from '../components/shared/utils/Data.svelte'
	import { fly } from 'svelte/transition';
	import LoginModal from '../components/shared/modal/Login.svelte';
	import ForbiddenModal from '../components/shared/modal/Forbidden.svelte';
	import MediaViewModal from '../components/shared/modal/MediaView.svelte';
	import MediaUploadModal from '../components/shared/modal/MediaUpload.svelte';
	import MapModal from '../components/shared/modal/Map.svelte';
	import Source from '../components/source/Source.svelte';
	import Item from '../components/source/Item.svelte';
	import Tree from '../components/source/Sidebar.svelte';
	import FormModal from '../components/shared/modal/Form.svelte';
	import FormsModal from '../components/shared/modal/Forms.svelte';
	import OptionModal from '../components/shared/modal/Option.svelte';
	import SummariesModal from '../components/shared/modal/Summaries.svelte';
	import SummaryModal from '../components/shared/modal/Summary.svelte';
	import ItemModal from '../components/shared/modal/Item.svelte';
	import { dataStore } from '../components/stores/source';
	import InfoModal from '../components/shared/modal/Info.svelte';

	export let vitals;
	export let messageToken;
	let mode = "";
	let tooltips = false;
	let polling = false;
	let lastPoll = (new Date(Date.now())).getTime();
	let previous = [];
	let forms = [];
	let templates = [];
	let featureId = "";
	let toast = null;
	let sidebar = false;
	let isPublic = false;
	let tables = [];
	let table = null;
	let links = {};
	let keys = {
		source: "1",
		content: "1",
		toast: "1",
		project: "1",
		modal: "1",
	}
	let project = {
		id: "0",
		name: "",
		tree: {},
		media: {}
	};
	let source = {
		type: "FeatureCollection",
		features: []
	};
	let tableId = "";
	let content = {
        id: "",
        view: ""
    };
	let modal = {
		view: ""
	};
	let session = {
    workspaces: []
	};
	if (localStorage.getItem("session")) {
		session = JSON.parse(localStorage.getItem("session"));
	}
	let contentViews = {
		source: Source,
		item: Item
	}
	let modalViews = {
		login: LoginModal,
		forbidden: ForbiddenModal,
		mediaView: MediaViewModal,
		mediaUpload: MediaUploadModal,
		form: FormModal,
		forms: FormsModal,
		map: MapModal,
		option: OptionModal,
		summaries: SummariesModal,
		summary: SummaryModal,
		item: ItemModal,
		info: InfoModal,
	}
	let settings = {
		newTab: false
	}
	let selectedTable = null;

	window.onpopstate = function (event) {
		var content = "";
		if (event.state) {
			content = event.state;
		}
		showContent(content);
	}

	onMount(async () => {
		var urlParams = new URLSearchParams(window.location.search);
		mode = urlParams.get("mode");
		if (!isTouchEnabled) {
			tooltips = false;
		}
		let params = (new URL(document.location)).searchParams;
		if (params.get("f") !== null) {
			featureId = params.get("f");
		}
		if (window.location.pathname != "/")
			tableId = window.location.pathname.substring(window.location.pathname.lastIndexOf("/") + 1);

		poll();

		if (params.get("public") !== null)
			isPublic = true;
		if (isPublic) {
			let [res, err] = await fetchData("/v1/session/table/" + tableId);
			if (err) {
				modal = {
					view: "forbidden"
				};
				return;
			}
			if (res.data) {
				session = res.data;
				getTable();
			}
			else {
				modal = {
					view: "passphrase"
				};
			}
		}
		else if (session.token) {
			polling = true;
			getTable();
			let [res, err] = await fetchData("/v1/session", {
				headers: {
					"Authorization": "Bearer " + session.token,
					"x-message-token": messageToken
				}
			});
			if (err == "invalid or expired jwt") {
				emailAuth()
			}
			else if (!err) {
				session = res.data;
				localStorage.setItem("session", JSON.stringify(session));
			}
		}
		else {
			emailAuth()
		}
  });

	async function emailAuth() {
		let [res, err] = await fetchData("/v1/session/email");
		if (!err) {
			session = res.data;
			localStorage.setItem("session", JSON.stringify(session));
			polling = true;
			loadCacheIndex(session.account, function () {
					getTable();
				});
		}
		else {
			modal = {
				view: "login"
			};
		}
	}

	function showContent(data) {
		if (data.table && data.table.source) {
				table = data.table;
				var ids = table.source.split("_");
				if (ids[0] == "source") {
					cachedFetch("/v1/sources/" + ids[1], ids[0], session.id, ids[1], {
							headers: {
									'Authorization': 'Bearer ' + session.token
							}
					}, function ([res, err]) {
						if (err) {
							modal = {
								view: "forbidden"
							};
							return;
						}
						else {
							//source = res;
							content = data;
							content.table = table;
							keys.content = generateID();
						}
					});
				}
				else if (ids[0] == "layer") {
					cachedFetch("/v1/layers/" + ids[1] + "_" + ids[2], ids[0], session.id, ids[1] + "_" + ids[2], {
							headers: {
									'Authorization': 'Bearer ' + session.token
							}
					}, function ([res, err]) {
						if (err) {
							modal = {
								view: "forbidden"
							};
							return;
						}
						else {
							//source = res;
							content = data;
							content.table = table;
							keys.content = generateID();
						}
					});
				}
			}
			else if (data.row && data.row[table.id_field]) {
				content = data;
				content.table = table;
				keys.content = generateID();
			}
	}

	function reportHandler(data) {
		var index = forms.findIndex(x => x.id == data.form);
		modal = {
				view: "map",
				form: forms[index],
				table: table
			}
	}

	function editHandler(data) {
		var index = forms.findIndex(x => x.id == data.form);
		if (forms[index].history) {
			modal = {
				view: "option",
				message: "Append a new history record?",
				handler: function responseHandler(data, response) {
						data.view = "form"
						data.history = response;
						modal = data;
				},
				data: {
					location: {
						status: "",
						enabled: false,
						label: "off"
					},
					mapId: table.id,
					mapName: table.name,
					form: forms[index],
					layer: table,
					map: null,
					feature: data.feature,
					back: data.back
				}
			}
		}
		else {
			modal = {
				view: "form",
				location: {
					status: "",
					enabled: false,
					label: "off"
				},
				mapId: table.id,
				mapName: table.name,
				form: forms[index],
				layer: table,
				map: null,
				feature: data.feature,
				back: data.back
			};
		}
	}

	function openModal(data) {
		if (!data.data.table) {
			data.data.table = selectedTable;
		}
		modal = data;
		keys.modal = generateID();
		modal = modal;
	}

	window.openModal = openModal;

	async function messageHandler(message) {
		if (message.detail.type == "report") {
			reportHandler(message.detail.data);
		}
		else if (message.detail.type == "edit") {
			editHandler(message.detail.data);
		}
		else if (message.detail.type == "content") {
			showContent(message.detail.data);
		}
		else if (message.detail.type == "modal") {
			modal = message.detail.data;
		}
		else if (message.detail.type == "session") {
			session = message.detail.data;
			if (!session.token) {
				localStorage.removeItem("session");
				await fetchData("/v1/session/end", {
					headers: {
						"Authorization": "Bearer " + session.token,
						"x-message-token": messageToken
					}
				});
				polling = false;
				window.location = "/";
			}
			else {
				localStorage.setItem("session", JSON.stringify(session));
				loadCacheIndex(session.account, function () {
					getTable();
				});
				polling = true;
			}
		}
		else if (message.detail.type == "filter") {
			keys.project = generateID();
		}
		else if (message.detail.type == "toast") {
			toast = message.detail.data;
			keys.toast = generateID();
			setTimeout(() => toast = null, 5000);
		}
	}
	async function getTable() {
		if (!tableId)
			return;

		let [res, err] = await fetchData("/v1/tables/" + tableId, {
			headers: {
				"Authorization": "Bearer " + session.token
			}
		});
		if (!err) {
			table = res.data;
			getProject(table.project)
		}
	}
	async function getProject(projectId) {
		project = {
			id: "0",
			name: "",
			tree: {},
			media: {}
		};
		loadCacheIndex(session.account, function () {
			if (hasCache("project", session.id + "_" + projectId)) {
				getCache("project", session.id + "_" + projectId, function (projectData) {
					project = projectData.data;
					keys.project = generateID();
					getSource();
					cachedFetch("/v1/projects/" + projectId, "project", session.id, projectId, {
						headers: {
								'Authorization': 'Bearer ' + session.token
						}
					});
				})
			}
			else {
				cachedFetch("/v1/projects/" + projectId, "project", session.id, projectId, {
					headers: {
							'Authorization': 'Bearer ' + session.token
					}
				}, function ([res, err]) {
						if (err) {
								console.log(err);
								getSource();
								return;
						}
						else if (res) {
							project = res.data
							keys.project = generateID();
							getSource();
						}
				});
			}
		})
	}
	async function getSource() {
		if (project.tree.tables) {
			tables = project.tree.tables;
		}

		if (table) {
			selectedTable = table;
			if (table.dynamic) {
				if (featureId) {
					var feature = {
						properties: {}
					};
					var ids = table.source.split("_");
					let [res, err] = await fetchData("/v1/tables/" + ids[1] + "_" + ids[2] + "/" + featureId, {
						headers: {
							"Authorization": "Bearer " + session.token
						}
					});
					if (!err) {
						if (res.features.length > 0)
							feature = res.features[0];
					}
					content = {
						view: "item",
						feature: feature,
						table: table
					};
					//history.pushState(content, "", window.location.href);
				}
				else {
					content = {
						view: "source",
						table: table
					};
					//history.pushState(content, "", window.location.href);
				}
			}
			else {
				var ids = table.source.split("_");
				if (ids[0] == "source") {
					cachedFetch("/v1/sources/" + ids[1], ids[0], session.id, ids[1], {
							headers: {
									'Authorization': 'Bearer ' + session.token
							}
					}, function ([res, err]) {
						if (err) {
							modal = {
								view: "forbidden"
							};
							return;
						}
						else {
							openSearchDb("source_" + ids[1], function() {
								if (featureId) {
									var feature = source.features.find(x => x.properties[table.id_field] === featureId);
									content = {
										view: "item",
										feature: feature,
										table: table
									};
									//history.pushState(content, "", window.location.href);
								}
								else {
									content = {
										view: "source",
										table: table
									};
									//history.pushState(content, "", window.location.href);
								}
							});
						}
					});
				}
				else if (ids[0] == "layer") {
					cachedFetch("/v1/layers/" + ids[1] + "_" + ids[2], ids[0], session.id, ids[1] + "_" + ids[2], {
							headers: {
									'Authorization': 'Bearer ' + session.token
							}
					}, function ([res, err]) {
						if (err) {
							modal = {
								view: "forbidden"
							};
							return;
						}
						else {
							openSearchDb("layer_" + ids[1] + "_" + ids[2], function() {
								if (featureId) {
									var feature = source.features.find(x => x.properties[table.id_field] === featureId);
									content = {
										view: "item",
										feature: feature,
										table: table
									};
									//history.pushState(content, "", window.location.href);
								}
								else {
									content = {
										view: "source",
										table: table
									};
									//history.pushState(content, "", window.location.href);
								}
							});
						}
					});
				}
			}
			if (table.role >= 2 && table.form) {
				var formId = table.form;
				if (hasCache("form", formId)) {
					getCache("form", formId, function (formData) {
						var index = forms.findIndex(x => x.id == formId);
						if (index == -1)
							forms.push(formData.data);
						else
							forms[index] = formData.data;
					})
				}
				cachedFetch("/v1/forms/" + formId, "form", session.id, formId, {
					headers: {
						'Authorization': 'Bearer ' + session.token
					}
				}, async function ([res, err]) {
					if (err) {
						console.log(err);
					}
					else if (res) {
						var index = forms.findIndex(x => x.id == formId);
						if (index == -1)
							forms.push(res.data);
						else
							forms[index] = res.data;
					}
				})
			}
			if (table.template || table.summaries) {
				var templateIds = [];
				if (table.summaries)
					templateIds = table.summaries.split(",");
				if (table.template)
					templateIds.push(table.template);
				templateIds.map(function (templateId) {
					if (hasCache("template", templateId)) {
						getCache("template", templateId, function (templateData) {
							var index = templates.findIndex(x => x.id == templateId);
							if (index == -1)
								templates.push(templateData.data);
							else
								templates[index] = templateData.data;
						})
					}
					cachedFetch("/v1/templates/" + templateId, "template", session.id, templateId, {
						headers: {
							'Authorization': 'Bearer ' + session.token
						}
					}, async function ([res, err]) {
						if (err) {
							console.log(err);
						}
						else if (res) {
							var index = templates.findIndex(x => x.id == templateId);
							if (index == -1)
								templates.push(res.data);
							else
								templates[index] = res.data;
						}
					})
				})
			}
			if (table.links) {
				table.links.split(",").map(async function (link) {
					let [res, err] = await fetchData("/v1/tables/" + link, {
						headers: {
							"Authorization": "Bearer " + session.token
						}
					});
					if (!err) {
						var linkedTable = res.data;
						tables[link] = linkedTable;
						if (!linkedTable.dynamic) {
							var ids = linkedTable.source.split("_");
							if (ids[0] == "source") {
								cachedFetch("/v1/sources/" + ids[1], ids[0], session.id, ids[1], {
										headers: {
												'Authorization': 'Bearer ' + session.token
										}
								});
							}
							else if (ids[0] == "layer") {
								cachedFetch("/v1/layers/" + ids[1] + "_" + ids[2], ids[0], session.id, ids[1] + "_" + ids[2], {
										headers: {
												'Authorization': 'Bearer ' + session.token
										}
								});
							}
						}
						if (linkedTable.role >= 2 && linkedTable.form) {
							var formId = linkedTable.form;
							if (hasCache("form", formId)) {
								getCache("form", formId, function (formData) {
									var index = forms.findIndex(x => x.id == formId);
									if (index == -1)
										forms.push(formData.data);
									else
										forms[index] = formData.data;
								})
							}
							cachedFetch("/v1/forms/" + formId, "form", session.id, formId, {
								headers: {
									'Authorization': 'Bearer ' + session.token
								}
							}, async function ([res, err]) {
								if (err) {
									console.log(err);
								}
								else if (res) {
									var index = forms.findIndex(x => x.id == formId);
									if (index == -1)
										forms.push(res.data);
									else
										forms[index] = res.data;
								}
							})
						}
					}
				})
			}
		}
	}
	function toggleSidebar() {
		sidebar = !sidebar;
	}
	function closeToast() {
		toast = null;
	}
	const sleep = m => new Promise(r => setTimeout(r, m))
	async function poll() {
		var errorDelay = 30000;
		if (!polling) {
			await sleep(5000);
			await poll();
			return;
		}
		var timeout = 45;  // in seconds
		var optionalSince = "&since_time=" + lastPoll;


		let [res, err] = await fetchData("/v1/events?timeout=" + timeout + "&category=" + session.account + optionalSince, {
			headers: {
				"Authorization": "Bearer " + session.token
			}
		})

		if (err) {
			await sleep(errorDelay);
			await poll();
			return;
		}

		if (res.error) {
			await sleep(errorDelay);
			await poll();
			return;
		}

		if (res && res.events && res.events.length > 0) {
			var obj = {};
			res.events.map(function (event) {
				if (event.data.old_val && event.data.new_val)
					obj["b_" + event.data.type + "_" + event.data.old_val.id + "_" + event.data.new_val.id] = event;
				else if (event.data.new_val)
					obj["a_" + event.data.type + "_" +event.data.new_val.id] = event;
				else if (event.data.old_val)
					obj["c_" + event.data.type + "_" +event.data.old_val.id] = event;
			})
			
			var hasUpdates = false;
			Object.keys(obj).sort().map(async function (key) {
				var event = obj[key];
				lastPoll = event.timestamp;
				if (event.data.type == "source" || event.data.type == "layer") {
					var path = "";
					if (event.data.type == "source") {
						path = event.data.id;
					}
					else {
						path = event.data.id + "_" + event.data.layer;
					}
					var id = "";
					if (event.data.type == "source")
						id = "source_" + event.data.id + "_" + event.data.layer;
					else
						id = "layer_" + event.data.id + "_" + event.data.layer;
					var old_val = event.data.old_val;
					var new_val = event.data.new_val;
					if (table.dynamic) {
						if (old_val && new_val) {
							let index = $dataStore.findIndex(x => x[event.data.idField] === old_val.properties[event.data.idField]);
							if (index != -1) {
								let properties = $dataStore[index];
								let geometry = $dataStore[index].geometry;
								$dataStore[index] = {...properties, ...new_val.properties};
								if (new_val.geometry) {
									$dataStore[index].geometry = new_val.geometry;
								}
							}
							$dataStore = $dataStore;
						}
						else if (new_val) {
							$dataStore.push({
								...new_val.properties,
								geometry: new_val.geometry
							});
							$dataStore = $dataStore;
						}
						else if (old_val) {
							let index = $dataStore.findIndex(x => x[event.data.idField] === old_val.properties[event.data.idField]);
							if (index != -1) {
								$dataStore.splice(index, 1);
								$dataStore = $dataStore;
							}
						}
					}
					else {
						layerChanged(event.data.type + "_" + path, event.data.idField, event.data.old_val, event.data.new_val, function(data) {
							//setCache(event.data.type, path, "", data);
							if (old_val && new_val) {
								let index = $dataStore.findIndex(x => x[event.data.idField] === old_val.properties[event.data.idField]);
								if (index != -1) {
									let properties = $dataStore[index];
									let geometry = $dataStore[index].geometry;
									$dataStore[index] = {...properties, ...new_val.properties};
									if (new_val.geometry) {
										$dataStore[index].geometry = new_val.geometry;
									}
								}
								$dataStore = $dataStore;
							}
							else if (new_val) {
								$dataStore.push({
									...new_val.properties,
									geometry: new_val.geometry
								});
								$dataStore = $dataStore;
							}
							else if (old_val) {
								let index = $dataStore.findIndex(x => x[event.data.idField] === old_val.properties[event.data.idField]);
								if (index != -1) {
									$dataStore.splice(index, 1);
									$dataStore = $dataStore;
								}
							}
						});
					}
					hasUpdates = true;
				}
			})
			if (hasUpdates) {
				toast = {
					message: "Table data has changed."
				}
				keys.toast = generateID();
				setTimeout(() => toast = null, 5000);
				hasUpdates = false;
			}
		}
		await poll();		
	}
</script>

<div class="app off-canvas {sidebar ? "off-canvas-sidebar-show" : ""}">
	<Identity key={keys.modal}>
	{#if modal}
		<svelte:component mode={mode} isPublic={isPublic} templates={templates} settings={settings} table={selectedTable} this={modalViews[modal.view]} modal={modal} session={session} tooltips={tooltips} messageToken={messageToken} on:message={messageHandler} />
	{/if}
	</Identity>
	
	{#if toast}
		<Identity key={keys.toast}>
			<div id="toast" class="toast toast-primary"  on:click={closeToast}  transition:fly="{{ y: 100, duration: 500 }}">
				<button class="btn btn-clear float-right"></button>
				{toast.message}
			</div>
		</Identity>
	{/if}
	{#if mode != "embed"}
	<div id="sidebar" class="off-canvas-sidebar {sidebar ? "active" : ""}">
		<div id="toggle-container">
			<button id="toggle" on:click={toggleSidebar} class="btn btn-primary btn-sm">
				<i class="icon {sidebar ? "icon-arrow-left" : "icon-arrow-right"}"></i>	
			</button>
		</div>
		<Identity key={session.account}>
			<Tree tooltips={tooltips} vitals={vitals} tableId={tableId} keys={keys} config={project} mapId={tableId} session={session} isPublic={isPublic} on:message={messageHandler} />
		</Identity>
	</div>
	{/if}
	<div class="off-canvas-content">
		{#if content}
			<Identity key={keys.content}>
				<svelte:component mode={mode} templates={templates} tooltips={tooltips} tables={tables} settings={settings} session={session} this={contentViews[content.view]} keys={keys} content={content} source={source} isPublic={isPublic} on:message={messageHandler} />
			</Identity>
		{/if}
	</div>
</div>

<style>
	.app {
		min-height: 100vh;
	}
	#toggle-container {
		position: fixed;
		width: 300px;
	}
	#toggle {
		position: absolute;
		right: 0;
		top: 0.15rem;
		margin-right: -1.4rem;
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}
	.app {
		min-height: 100vh;
	}
	.off-canvas-sidebar {
		width: 300px;
	}
	#toast {
		position: fixed;
		right: 1rem;
		bottom: 1rem;
		width: 300px;
		z-index: 9999;
	}
	#sidebar {
		overflow: visible;
	}
	.off-canvas .off-canvas-content {
		padding: 0;
	}
	@media (min-width: 960px) {
	.off-canvas.off-canvas-sidebar-show .off-canvas-sidebar {
			flex: 0 0 auto;
			position: fixed;
			transform: none;
		}
	}
</style>